import { RenderIf } from 'react-rainbow-components';
import { useNavigate, useParams } from 'react-router-dom';
import { StyledBreadcrumb, StyledBreadcrumbs } from 'components/Breadcrumbs';
import ListIcon from 'components/icons/list';
import useSession from 'data/firestore/session/use';
import Footer from 'components/Footer';
import Alert from 'components/Alert';
import DownloadCallRecordingButton from 'components/DownloadCallRecordingButton';
import { EntityGet } from 'data/firestore/types';
import { Session } from 'data/firestore/session/types';
import useSessionCustomer from 'data/hooks/useSessionCustomer';
import ButtonIcon from 'components/ButtonIcon';
import ArrowLeftIcon from 'components/icons/arrowLeft';
import useNavigateWithQuery from 'hooks/useNavigateWithQuery';
import { Customer } from 'data/firestore/agent/customer/types';
import Transcript from './Transcript';
import Details from './Details';
import {
    Columns,
    Container,
    LeftColumn,
    RightColumn,
    RightContent,
    ConversationCardTitle,
    HeaderContainer,
    StyledReportButton,
} from './styled';

const ConversationDetails = () => {
    const { agentId = '', sessionId = '' } = useParams();
    const { data: session, isLoading: isLoadingSession } = useSession(sessionId as string);
    const {
        customer,
        isLoading: isLoadingCustomer,
    } = useSessionCustomer(
        session as Session,
        {
            disabled: isLoadingSession || !session,
        },
    );
    const navigate = useNavigate();
    const navigateWithQuery = useNavigateWithQuery();
    const isSpam = session?._tags?.includes('spam');
    const isLoading = isLoadingSession || isLoadingCustomer;

    return (
        <Container>
            <HeaderContainer>
                <ButtonIcon
                    icon={<ArrowLeftIcon />}
                    onClick={() => navigateWithQuery(`/${agentId}/voip/history`)}
                    size="small"
                />
                <StyledBreadcrumbs>
                    <StyledBreadcrumb label="History" onClick={() => navigate(`/${agentId}/voip/history`)} />
                    <StyledBreadcrumb label="Conversation Details" />
                </StyledBreadcrumbs>
            </HeaderContainer>
            <Columns>
                <LeftColumn>
                    <Details
                        sessionId={sessionId}
                        data={{
                            ...(session || {}) as EntityGet<Session>,
                            customer,
                        }}
                        isLoading={isLoading}
                    />
                </LeftColumn>
                <RightColumn
                    title={(
                        <ConversationCardTitle>
                            <ListIcon />
                            <span>
                                Transcript & Recording
                            </span>
                        </ConversationCardTitle>
                    )}
                    actions={(
                        <>
                            <StyledReportButton
                                agentId={agentId}
                                context={{
                                    type: 'call',
                                    sessionId,
                                }}
                                variant="base"
                                borderRadius="semi-rounded"
                                size="medium"
                                disabled={isLoading}
                            />
                            <DownloadCallRecordingButton
                                variant="base"
                                borderRadius="semi-rounded"
                                size="medium"
                                conversationId={sessionId}
                                recordingId={session?.recordingId}
                            />
                        </>
                    )}
                >
                    <RightContent>
                        <RenderIf isTrue={!isSpam}>
                            <Transcript
                                sessionId={sessionId}
                                from={customer as Customer}
                                recordingId={session?.recordingId}
                                status={session?.status}
                                sip={session?.sip}
                                direction={session?.direction}
                            />
                        </RenderIf>
                        <RenderIf isTrue={isSpam}>
                            <Alert variant="error">
                                This phone number was detected as a spam risk.
                            </Alert>
                        </RenderIf>
                    </RightContent>
                </RightColumn>
            </Columns>
            <Footer />
        </Container>
    );
};

export default ConversationDetails;
